<template>
  <img class="img" src="/assets/image/bg.jpg" />
</template>

<script>

export default {
  name: "Background"
}
</script>

<style scoped>
  .img{
    position: absolute;
    z-index: -999;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
